import { authCookie } from "helper/cookie";
import { toast } from "react-toastify";
import { all, put, takeLatest } from "redux-saga/effects";
import { clearStoredSelectedDate } from "modules/Birthday/redux/selectedDate";
import { logoutFailed, logoutStart, logoutSuccess } from "../redux/logout";
import { resetLogin } from "../redux/login";

function* logoutWork(action: ReturnType<typeof logoutStart>) {
  try {
    yield put({
      type: resetLogin.type,
    });
    authCookie.reset();
    clearStoredSelectedDate();

    const message = action.payload.toastMsg;

    if (message) {
      toast.success(message);
    }
    yield put({
      type: logoutSuccess.type,
    });
  } catch (error: any) {
    yield put({
      type: logoutFailed.type,
    });
  }
}

function* watchLogout() {
  yield takeLatest(logoutStart.type, logoutWork);
}
export default function* logoutSaga() {
  yield all([watchLogout()]);
}
